import { render, staticRenderFns } from "./PartsFooter.vue?vue&type=template&id=4f63ac65&"
import script from "./PartsFooter.vue?vue&type=script&lang=js&"
export * from "./PartsFooter.vue?vue&type=script&lang=js&"
import style0 from "./PartsFooter.vue?vue&type=style&index=0&id=4f63ac65&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports